var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGroupCirclesRight = function SvgGroupCirclesRight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 115 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    r: 49,
    transform: "matrix(-1 0 0 1 66 49)",
    fill: "#8ED6C9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    r: 14,
    transform: "scale(-1 1) rotate(-7.377 958.816 349.99)",
    fill: "#82C6FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    r: 7,
    transform: "matrix(-1 0 0 1 7 91)",
    fill: "#FFD67C"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGroupCirclesRight);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTE1IDE0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIG9wYWNpdHk9Ii44IiByPSI0OSIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgNjYgNDkpIiBmaWxsPSIjOEVENkM5Ii8+PGNpcmNsZSBvcGFjaXR5PSIuOCIgcj0iMTQiIHRyYW5zZm9ybT0ic2NhbGUoLTEgMSkgcm90YXRlKC03LjM3NyA5NTguODE2IDM0OS45OSkiIGZpbGw9IiM4MkM2RkYiLz48Y2lyY2xlIG9wYWNpdHk9Ii44IiByPSI3IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSA3IDkxKSIgZmlsbD0iI0ZGRDY3QyIvPjwvc3ZnPg==";